import {ConditionProcessorBase} from "FormBuilder/Core/Conditions/ConditionProcessorBase";
import {ImageCondition} from "./ImageConditionOptions";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";
import {ConditionOptionsBase} from "FormBuilder/Fields/Core/ConditionOptions";


export class ImageConditionProcessor extends ConditionProcessorBase{
    public Options:ImageCondition;
    public static RootProcessors:ImageConditionProcessor=null;
    public static DefaultImages:string[]=null;
    public static CustomImages:string[]=[];

    Initialize(formBuilder: ContainerDataRetriever, condition: ConditionOptionsBase): this {
        if(ImageConditionProcessor.DefaultImages==null)
        {
            ImageConditionProcessor.DefaultImages=[];
            jQuery('.woocommerce-product-gallery img').each((index,element:any)=>{
                ImageConditionProcessor.DefaultImages.push(element.attributes.src.value)
            });
        }
        return super.Initialize(formBuilder, condition);
    }

    ExecuteFalseAction(immediate: boolean) {
        if(ImageConditionProcessor.RootProcessors==null)
        {
            ImageConditionProcessor.RootProcessors=this;
        }
        for(let image of this.Options.Images)
        {
            let url=image.URL;
            if(ImageConditionProcessor.CustomImages.indexOf(url)>=0)
            {
                ImageConditionProcessor.CustomImages.splice(ImageConditionProcessor.CustomImages.indexOf(url),1);
            }
        }

        if(ImageConditionProcessor.RootProcessors==this)
        {
            this.UpdateImages();
            ImageConditionProcessor.RootProcessors=null;
        }

    }

    ExecuteTruAction(immediate: boolean) {
        if(ImageConditionProcessor.RootProcessors==null)
        {
            ImageConditionProcessor.RootProcessors=this;
        }
        for(let image of this.Options.Images)
        {
            let url=image.URL;
            if(ImageConditionProcessor.CustomImages.indexOf(url)==-1)
            {
                ImageConditionProcessor.CustomImages.push(url);
            }
        }


        if(ImageConditionProcessor.RootProcessors==this)
        {
            this.UpdateImages();
            ImageConditionProcessor.RootProcessors=null;
        }
    }

    private UpdateImages() {
        let images:string[];
        if(ImageConditionProcessor.CustomImages.length>0)
            images=ImageConditionProcessor.CustomImages;
        else
            images=ImageConditionProcessor.DefaultImages;


        let html=`<div class="woocommerce-product-gallery woocommerce-product-gallery--with-images woocommerce-product-gallery--columns-4 images" data-columns="4" style="opacity: 0; transition: opacity .25s ease-in-out;">
                    <figure class="woocommerce-product-gallery__wrapper">`;

        for(let url of images)
        {
            html+=` <div data-thumb="${url}" data-thumb-alt="" class="woocommerce-product-gallery__image">
                        <a href="${url}">
                            <img width="100" height="100" src="${url}" class="wp-post-image" alt="" title="_background" data-caption="" data-src="${url}" data-large_image="${url}" data-large_image_width="1000" data-large_image_height="1000">
                        </a>
                     </div>`;
        }

        html+=      `</figure>
                    </div>`;

        if(typeof (jQuery.fn as any).wc_product_gallery=='undefined')
        {
            setTimeout(()=>this.UpdateImages(),100);
            return;
        }

        jQuery('.woocommerce-product-gallery').replaceWith(html);
        let params=null;
        if(typeof wc_single_product_params!="undefined" )
            params=wc_single_product_params;
        (jQuery( '.woocommerce-product-gallery') as any).wc_product_gallery(params);




    }
}